// take2supply: quick-add for the "Add another piece" cart nudge. Mirrors the theme's product-form add flow
// so the cart drawer, cart page and cart count all refresh in place.
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__t2sAddonReady) {
  window.__t2sAddonReady = true;
  document.addEventListener('click', async (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-t2s-addon]') : null;
    if (!btn || btn.disabled) return;
    event.preventDefault();
    const variantId = btn.dataset.variantId;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const res = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
      }).then((r) => r.json());
      const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const failed = Boolean(res.status);
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 't2s-cart-addon',
          itemCount: 1,
          sections: failed ? undefined : res.sections,
          didError: failed,
        },
      });
      if (failed) {
        btn.textContent = 'Unavailable';
      }
    } catch (err) {
      deferred.reject(err);
      btn.disabled = false;
      btn.textContent = label;
    }
  });
}
